import { ReactNode } from "react";

import { Content } from "./content";

export const NewUser = (props: {
    SiteNameInput?: ReactNode;
    SubmitButton?: ReactNode;
    PrivacyPolicy?: ReactNode;
}) => <Content {...props} />;
